import { render, staticRenderFns } from "./ConnectedMembers.vue?vue&type=template&id=a147dc5e&scoped=true"
import script from "./ConnectedMembers.vue?vue&type=script&lang=js"
export * from "./ConnectedMembers.vue?vue&type=script&lang=js"
import style0 from "./ConnectedMembers.vue?vue&type=style&index=0&id=a147dc5e&prod&lang=scss&scoped=true"
import style1 from "./ConnectedMembers.vue?vue&type=style&index=1&id=a147dc5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a147dc5e",
  null
  
)

export default component.exports